import { render } from "./TableButton.vue?vue&type=template&id=6c4611d2&scoped=true"
import script from "./TableButton.vue?vue&type=script&lang=js"
export * from "./TableButton.vue?vue&type=script&lang=js"

import "./TableButton.vue?vue&type=style&index=0&id=6c4611d2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4611d2"]])

export default __exports__